export type TMenuLayout = 'sidebar' | 'top'

export const DEFAULT_MENU_LAYOUT: TMenuLayout = 'sidebar'

const SIDEBAR_EXPANDED_KEY = 'sidebar-expanded'

/** Выбор пользователя из localStorage: по умолчанию сайдбар свёрнут */
export const getStoredSidebarExpanded = () => localStorage.getItem(SIDEBAR_EXPANDED_KEY) === 'true'

export const storeSidebarExpanded = (expanded: boolean) =>
  localStorage.setItem(SIDEBAR_EXPANDED_KEY, String(expanded))
